import { itx } from "../../../src/translationItx/itx";
import { useEffect, useRef, useState } from "react";
import { setSession } from "../../../src/components/account/auth-helper";
import EditProfileDialog from "../../../src/components/EditProfileDialog";
import { useOnChangeWatcher } from "../../../src/models/useOnChangeWatcher";

type C1_UserAvatarProps = {
  logoutTarget: string;
};

export function C1_UserAvatar({ logoutTarget }: C1_UserAvatarProps) {
  useOnChangeWatcher(state.profilePicture);
  const user = state.loggedInUser;
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const profilePicture = localStorage.getItem(`profilePicture${user?.id || ""}`);
  const initials = (user?.name || user?.email || itx("step2.diningRoomTag", "ES"))
    .split(/[\s.@]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part: string) => part[0])
    .join("")
    .toUpperCase();

  useEffect(() => {
    if (!menuOpen) return;
    const closeMenu = (event: MouseEvent) => {
      if (!menuRef.current?.contains(event.target as Node)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", closeMenu);
    return () => document.removeEventListener("mousedown", closeMenu);
  }, [menuOpen]);

  return (
    <div className={`menu-item-wrapper${menuOpen ? " menu-open" : ""}`} ref={menuRef} style={{ padding: 5 }}>
      <button
        type="button"
        className="C1_userAvatarButton"
        aria-label={itx("c1.ui.Benutzermenu_offnen", "Benutzermenü öffnen")}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((open) => !open)}
      >
        {profilePicture ? (
          <img className="profP" src={profilePicture} alt="" />
        ) : (
          <span className="profP C1_userAvatarInitials" aria-hidden="true">{initials}</span>
        )}
      </button>

      {menuOpen && (
        <div className="user-menu C1_userMenu">
          <div className="user-menu-title">
            {user?.name && <strong>{user.name}</strong>}
            <span>{user?.email}</span>
          </div>
          <button
            type="button"
            className="user-menu-item"
            onClick={() => {
              setMenuOpen(false);
              state.dialogManager.openDialog(<EditProfileDialog />);
            }}
          >
            <i className="las la-edit" />  {itx("menuBar.editProfile", "Profil bearbeiten")} </button>
          <button
            type="button"
            className="user-menu-item"
            onClick={() => {
              setMenuOpen(false);
              setSession(null);
              localStorage.setItem("user", "");
              state.navigate(logoutTarget);
            }}
          >
            <i className="las la-sign-out-alt" />  {itx("c1.ui.Logout", "Logout")} </button>
        </div>
      )}
    </div>
  );
}
